<script setup lang="ts">
import PlusIcon from '@/assets/icons/PlusIcon.vue';
</script>

<template>
  <div :class="['flex items-center justify-center', 'bg-white shrink-0', 'border-1 border-divider !rounded-sm']">
    <PlusIcon class="size-icon text-secondary" />
    <slot />
  </div>
</template>
